<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    menu-props="offsetY"
    top
  >
    <a
      slot="activator"
      class="title"
    >...</a>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.trademark?props.item.trademark.title:"" }}</td>
          <td>{{ props.item.model?props.item.model.title:"" }}</td>
          <td>{{ props.item.nomenclature?props.item.nomenclature.title:"" }}</td>
          <td>{{ props.item.article?props.item.article.title:"" }}</td>
          <td>{{ props.item.material }}</td>
          <td>{{ props.item.site }}</td>
          <td>{{ props.item.factoryMarking }}</td>
          <td>{{ props.item.country?props.item.country.title:"" }}</td>
          <td>{{ props.item.category?props.item.category.title:"" }}</td>
          <td>{{ props.item.unit?props.item.unit.title:"" }}</td>
          <td>{{ props.item.quantity }}</td>
          <td>{{ props.item.places }}</td>
          <td>{{ props.item.size }}</td>
          <td>{{ props.item.weigthNetto }}</td>
          <td>{{ props.item.weightBrutto }}</td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          flat
          @click="menu = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      menu: false,
      headers: [
        { text: "ТМ", sortable: false },
        { text: "Модель", sortable: false },
        { text: "Номенклатура", sortable: false },
        { text: "Артикул", sortable: false },
        { text: "Материал", sortable: false },
        { text: "Сайт", sortable: false },
        { text: "Маркировка на фабрике", sortable: false },
        { text: "Страна", sortable: false },
        { text: "Категория", sortable: false },
        { text: "Ед. изм", sortable: false },
        { text: "Кол-во", sortable: false },
        { text: "Мест", sortable: false },
        { text: "Размер", sortable: false },
        { text: "Вес нетто", sortable: false },
        { text: "Вес брутто", sortable: false },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.getters["shipping/goodsDetails"];
    },
  },
};
</script>
